import { LOG_OUT_USER, UPDATE_AUTHORIZED, VERIFY_TOKEN } from "../../actions/actionTypes";

const finishedAuthCheckReducer = (state=false, action) => {
    let  finished = state;
    
    switch(action.type){ 
        case VERIFY_TOKEN:
            return true;
        case UPDATE_AUTHORIZED: // this will change this value in situations where the token doesn't have to be verified eg. Login/Register
            return true
        case LOG_OUT_USER:
            return false;
        default:
            return finished;
    }
    
};

export default finishedAuthCheckReducer;